import React from "react";

const ButtonBox = ({ children }) => {
  return <div className="button-box">{children}</div>;
};

export default ButtonBox;
